import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-row w-full justify-end items-center gap-4 pt-4" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "flex-1 items-start lg:items-end flex flex-col lg:flex-row gap-3 mt-3" }
const _hoisted_4 = { class: "flex flex-row gap-1" }
const _hoisted_5 = { class: "flex flex-row gap-1" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "my-3" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col my-2"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold mb-3" }, "Registros", -1)
const _hoisted_11 = { class: "flex flex-col gap-3" }
const _hoisted_12 = { class: "flex justify-between" }
const _hoisted_13 = { class: "text-base font-bold" }
const _hoisted_14 = { class: "text-sm font-light text-gray-600" }
const _hoisted_15 = { class: "text-sm font-light" }
const _hoisted_16 = {
  key: 1,
  class: "p-2 border rounded-lg text-center"
}

import { onMounted, ref, Ref } from "vue";
import { useRouter } from "vue-router";
import { InvestmentService } from "@/services/invest/investmentService";
import { Investment, Record } from "@/services/invest/types";
import {
  reformatDateDayMonth,
  toBadgeFormat,
  toBadgeFormatUf,
} from "@/services/utils";

import NewModal from "../atoms/NewModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewInvestimentModal',
  props: {
  visible: {
    type: Boolean,
    default: false,
  },
  invest: {
    type: Investment,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const router = useRouter();

const investimentService = new InvestmentService();
const records: Ref<Record[]> = ref([]);
async function getInvestiment() {
  let result = null;
  try {
    if (props.invest.id) {
      result = await investimentService.getRecords(props.invest.id);
      records.value = result.data;
    }
  } catch (error) {
    console.log(error);
  }
  return result;
}

onMounted(() => {
  getInvestiment();
});

return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(NewModal, {
      title: 'Registros y detalle de: ' + __props.invest?.title,
      visible: __props.visible,
      "onUpdate:visible": _cache[1] || (_cache[1] = (e) => _ctx.$emit('update:visible', e))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
            () =>
              _ctx.$router.push({
                name: 'investmentContracts',
                params: { id: __props.invest.id },
              })
          ),
            class: "rounded-full bg-green-700 hover:scale-110 transition text-sm hover:text-white text-white font-medium px-4 py-1.5 shadow-md"
          }, " Ir a contratos ")
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_mdicon, {
                name: "sack",
                size: "22"
              }),
              _createTextVNode(" Valor de compra: UF " + _toDisplayString(_unref(toBadgeFormat)(__props.invest.value)), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_mdicon, {
                name: "cash",
                size: "22"
              }),
              (__props.invest.monthlyProfitabilityClp)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Renta: $" + _toDisplayString(_unref(toBadgeFormat)(__props.invest.monthlyProfitabilityClp ?? 0)) + " mes ", 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_7, " Renta: UF " + _toDisplayString(_unref(toBadgeFormatUf)(__props.invest.monthlyProfitabilityUf ?? 0)), 1))
            ])
          ]),
          _createElementVNode("p", _hoisted_8, _toDisplayString(__props.invest?.description), 1),
          (records.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("ul", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(records.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "border-b mt-2 pb-2",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("p", _hoisted_13, _toDisplayString(item.title), 1),
                        _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(reformatDateDayMonth)(item.createdAt as string)), 1)
                      ]),
                      _createElementVNode("p", _hoisted_15, _toDisplayString(item.description), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_16, " Esta inversión no cuenta con registros "))
        ])
      ]),
      _: 1
    }, 8, ["title", "visible"])
  ]))
}
}

})